export function createMarkup(str) {
	return {__html: str};//.replace(/\n/g, '<br>')};
};

export function processLines(str) {
	if (!str) return [];
	return str.split('\n');
}